import { render } from "./WhyWait.vue?vue&type=template&id=40daa7c1&scoped=true"
import script from "./WhyWait.vue?vue&type=script&lang=js"
export * from "./WhyWait.vue?vue&type=script&lang=js"

import "./WhyWait.vue?vue&type=style&index=0&id=40daa7c1&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40daa7c1"]])

export default __exports__